<template>
    <div :class="$props.imageClasses">
        <img        
            class="w-full h-auto"
            :src="$props.imageSrc"
            :alt="$props.imageAlt"
        />        
    </div>
</template>

<script>
export default {
    props: {
        imageSrc: { type: String, required: true },
        imageAlt: { type: String, default: '' },
        imageClasses: { type: String, default: '' }        
    }  
}
</script>